/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React from 'react';
import { Card, Divider, Button } from 'antd';
import Errors from './errors';

import * as contractValues from '../optionsJson/contract';

const displayData = (value, location = null) => {
  if (!value) {
    return '-';
  }
  if (value && !location) {
    return value;
  } else if (contractValues[location][value]) {
    return `${contractValues[location][value]} `;
  }
  return '-';
};

const Header = block => {
  const { data, changeMenu, validation, quoteValues } = block;
  console.log(block);

  const getFldNameKey = validationArray => {
    const keys = {};
    validationArray.forEach((element, i) => {
      keys[element.fldName] = i;
    });
    return keys;
  };

  const validatationKeys = getFldNameKey(validation);

  if (!data) {
    return <div>No Contract Data Provided</div>;
  }

  return (
    <div className="subcomponent-wrapper">
      <div className="subcomponent-header">Contract</div>
      <Card>
        <div className="inline">
          <div>
            Bid Type: <p>{displayData(data.bidTypeCd, 'bidType')}</p>
          </div>
          <div>
            Vendor Quote #: <p>{displayData(data.vendQuoteNum)}</p>
          </div>
        </div>
        {validatationKeys && validatationKeys.bidTypeCd ? (
          <Errors validation={validation[validatationKeys.bidTypeCd]} />
        ) : (
          <div />
        )}
        {validatationKeys && validatationKeys.vendQuoteNum ? (
          <Errors validation={validation[validatationKeys.vendQuoteNum]} />
        ) : (
          <div />
        )}
        <div className="inline">
          <div>
            Prompt Payment Discount Terms:{' '}
            <p>{displayData(data.prmptPayDscnt, 'discountCodes')}</p>
          </div>
          <div>
            Quote Valid for: <p>{displayData(data.daysValid)} days</p>
          </div>
        </div>
        {validatationKeys && validatationKeys.prmptPayDscnt ? (
          <Errors validation={validation[validatationKeys.prmptPayDscnt]} />
        ) : (
          <div />
        )}
        {validatationKeys && validatationKeys.daysValid ? (
          <Errors validation={validation[validatationKeys.daysValid]} />
        ) : (
          <div />
        )}
        <div className="inline">
          <div>
            Meets Packaging Requirements?:{' '}
            <p>{displayData(data.acceptPkg, 'yesOrNo')}</p>
          </div>
        </div>
        {validatationKeys && validatationKeys.acceptPkg ? (
          <Errors validation={validation[validatationKeys.acceptPkg]} />
        ) : (
          <div />
        )}
        <div className="inline">
          <div>
            Fob Point: <p>{displayData(data.fobPoint, 'destOrigin')}</p>
          </div>
        </div>
        {validatationKeys && validatationKeys.fobPoint ? (
          <Errors validation={validation[validatationKeys.fobPoint]} />
        ) : (
          <div />
        )}
        <div className="inline">
          <div>
            City: <p>{displayData(data.fobCity)}</p>
          </div>
          <div>
            State: <p>{displayData(data.fobStProv)}</p>
          </div>
          <div>
            Country: <p>{displayData(data.fobCntry)}</p>
          </div>
        </div>
        {validatationKeys && validatationKeys.fobCity ? (
          <Errors validation={validation[validatationKeys.fobCity]} />
        ) : (
          <div />
        )}
        {validatationKeys && validatationKeys.fobStProv ? (
          <Errors validation={validation[validatationKeys.fobStProv]} />
        ) : (
          <div />
        )}
        {validatationKeys && validatationKeys.fobCntry ? (
          <Errors validation={validation[validatationKeys.fobCntry]} />
        ) : (
          <div />
        )}
        <div className="inline">
          <div>
            Federal Supply Schedule (FSS)/Basic Ordering Amount (BOA)/ Blanket
            Purchase Agreement:{' '}
            <p>{displayData(data.boaFssBpa, 'boaFssBpa')}</p>
          </div>
        </div>
        {validatationKeys && validatationKeys.boaFssBpa ? (
          <Errors validation={validation[validatationKeys.boaFssBpa]} />
        ) : (
          <div />
        )}
        <div className="inline">
          <div>
            Federal Supply Schedule (FSS)/Basic Ordering Amount (BOA)/ Blanket
            Purchase Agreement Experation Date :{' '}
            <p>{displayData(data.boaFssBpaExp)}</p>
          </div>
          <div>
            Contract Number: <p>{displayData(quoteValues.boaFssBpaNum)}</p>
          </div>
        </div>
        {validatationKeys && validatationKeys.boaFssBpaExp ? (
          <Errors validation={validation[validatationKeys.boaFssBpaExp]} />
        ) : (
          <div />
        )}
        <div className="inline">
          <div>
            Place of Government Inspection – Packaging CAGE code :{' '}
            <p>{displayData(quoteValues.plcGovPkgInsptnCage)}</p>
          </div>
          <div>
            Supplies Cage Code:{' '}
            <p>{displayData(quoteValues.plcGovSupInsptnCage)}</p>
          </div>
        </div>
        {validatationKeys && validatationKeys.plcGovPkgInsptnCage ? (
          <Errors
            validation={validation[validatationKeys.plcGovPkgInsptnCage]}
          />
        ) : (
          <div />
        )}
        {validatationKeys && validatationKeys.plcGovSupInsptnCage ? (
          <Errors
            validation={validation[validatationKeys.plcGovSupInsptnCage]}
          />
        ) : (
          <div />
        )}
        <div className="inline">
          <div>
            Contract #:<p>{displayData(quoteValues.boaFssBpaNum)}</p>
          </div>
          <div>
            Expiration Date:<p>{displayData(quoteValues.boaFssBpaExp)}</p>
          </div>
        </div>
        {validatationKeys && validatationKeys.boaFssBpaNum ? (
          <Errors validation={validation[validatationKeys.boaFssBpaNum]} />
        ) : (
          <div />
        )}
        {validatationKeys && validatationKeys.boaFssBpaExp ? (
          <Errors validation={validation[validatationKeys.boaFssBpaExp]} />
        ) : (
          <div />
        )}

        <div className="inline">
          <div>
            Government Inspection Point:{' '}
            <p>{displayData(data.insptnPointCd, 'destOrigin')}</p>
          </div>
        </div>
        {validatationKeys && validatationKeys.insptnPointCd ? (
          <Errors validation={validation[validatationKeys.insptnPointCd]} />
        ) : (
          <div />
        )}

        <div className="inline">
          <div>
            SPI Process Proposed:{' '}
            <p>{displayData(quoteValues.subSpiProcPropsd)}</p>
          </div>
          <div>
            SPI Process: <p>{displayData(quoteValues.spiProc)}</p>
          </div>
          <div>
            SPI Facility: <p>{displayData(quoteValues.spiFacility)}</p>
          </div>
        </div>
        {validatationKeys && validatationKeys.subSpiProcPropsd ? (
          <Errors validation={validation[validatationKeys.subSpiProcPropsd]} />
        ) : (
          <div />
        )}
        {validatationKeys && validatationKeys.spiProc ? (
          <Errors validation={validation[validatationKeys.spiProc]} />
        ) : (
          <div />
        )}
        {validatationKeys && validatationKeys.spiFacility ? (
          <Errors validation={validation[validatationKeys.spiFacility]} />
        ) : (
          <div />
        )}
        <div className="inline">
          <div>
            SPI Military or Federal Specification or Standard:{' '}
            <p>{displayData(quoteValues.spiMilSpec)}</p>
          </div>
          <div>
            Contract Line Items, Subline Items, Component, or element affected:{' '}
            <p>{displayData(quoteValues.spiAffectedClin)}</p>
          </div>
        </div>
        {validatationKeys && validatationKeys.spiMilSpec ? (
          <Errors validation={validation[validatationKeys.spiMilSpec]} />
        ) : (
          <div />
        )}
        {validatationKeys && validatationKeys.spiAffectedClin ? (
          <Errors validation={validation[validatationKeys.spiAffectedClin]} />
        ) : (
          <div />
        )}

        <div className="inline">
          <div>
            Certification Regarding Knowledge of Child Labor for Listed End
            Products:
            <p>{displayData(data.chldLbrCertCd, 'childCode')}</p>
          </div>
        </div>

        <div className="edit-button-dibbs">
          <Button
            type="primary"
            onClick={() => {
              changeMenu('contract');
            }}
          >
            Edit
          </Button>
        </div>
      </Card>

      <Divider />
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/reviewComponents/contract.jsx